import Component, { LeadGenerationFormProps } from '.';
import { MapProps } from '../../BlockMapper';
import TestData from './test.data';

const _map = (block: any, test = false) => {
  const data = test ? TestData : MapProps(block);
  const props: LeadGenerationFormProps = { ...data };
  return <Component {...props} />;
};

export default _map;
